import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { noSpinnerHeader, noSpinnerTrueValue } from '../spinner/spinner.service';
import { Location } from './location.model';

@Injectable()
export class AddressService {
    constructor(private httpService: HttpClient) {
    }

    findSuggestions(partialAddressText: string, site: string): Observable<Location[]> {
        return this.httpService.get<Location[]>('address', {
            headers: new HttpHeaders().set(noSpinnerHeader, noSpinnerTrueValue),
            params: new HttpParams()
                .set('address', partialAddressText)
                .set('site', site)
        });
    }
}
